import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, message, Modal, Row, Switch } from "antd";

import { departmentsService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UISwitchField,
} from "./../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Edit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
			uuid: 0,
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
		});

		departmentsService.show({ uuid })
			.then((response) => {
				const item = response.data.data;

				this.setState({
					isLoading: false,
				}, () => {
					// Fill form
					this.fillForm(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	fillForm = (data) => {
		this.form.setFieldsValue({
			nome: data.nome,
			numero_folha: data.numero_folha,
			ativo: data.ativo == 1,
		});
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		const data = {
			...values,
			uuid: this.state.uuid,
		};

		departmentsService.edit(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Success message
				message.success("Registro atualizado com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	render() {
		const { visible } = this.props;

		const { isLoading, isSending } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-sitemap" />}
				title="Editar departamento"
				subtitle="Atualize as informações do departamento.">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}>
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Dados de identificação do departamento.">
						<Row gutter={16}>
							<Col xs={24} md={16}>
								<Form.Item name="nome" label="Nome" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
									<Input placeholder="Ex.: Operacional" />
								</Form.Item>
							</Col>
							<Col xs={24} md={8}>
								<Form.Item name="numero_folha" label="Número da folha" hasFeedback>
									<Input placeholder="Opcional" />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Status">
									<UISwitchField
										bordered
										title="Ativo"
										description="Departamento disponível para vincular funcionários.">
										<Form.Item name="ativo" valuePropName="checked" noStyle>
											<Switch />
										</Form.Item>
									</UISwitchField>
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Edit;
